// src/components/UserInfo.js
import React from "react";

const UserInfo = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user) {
    return (
      <div className="p-6 text-center text-red-600">
        ❌ User not found. Please login again.
      </div>
    );
  }

  const username = user.fullName || user.username;
  const categoryPath = user.categoryPath || [];

  return (
    <div className="bg-gray-100 p-4 rounded-lg shadow mb-6">
      <p>
        <strong>Name:</strong> {username}
      </p>
      <p>
        <strong>Role:</strong> {user.role}
      </p>
      {user.phone && (
        <p>
          <strong>Phone:</strong> {user.phone}
        </p>
      )}
      <p>
        <strong>Categories:</strong> {categoryPath.join(", ") || "None"}
      </p>
    </div>
  );
};

export default UserInfo;
